import { useIntl } from '@/intl'
import { Banner } from '@sunwebgroup/uds-ui/banner'
import { Button } from '@sunwebgroup/uds-ui/button'
import { Dialog } from '@sunwebgroup/uds-ui/dialog'
import { TextField } from '@sunwebgroup/uds-ui/fields/text-field'
import cn from 'classnames'
import * as React from 'react'
import { AlertServiceErrorBanner } from './AlertServiceErrorBanner'
import styles from './AlertServiceSidebar.module.css'
import { useAlertService } from './hooks'

export interface AlertServiceSidebarProps {
  contextItemId: string
  alertServiceDataSourceId?: string
  accommodationId?: number
  showBorder?: boolean
}
export function AlertServiceSidebar({
  contextItemId,
  alertServiceDataSourceId,
  accommodationId,
  showBorder = false,
}: AlertServiceSidebarProps): React.ReactElement {
  const intl = useIntl()
  const [email, setEmail] = React.useState('')
  const [isValidEmail, setIsValidEmail] = React.useState(true)
  const { mutate, isLoading, isSuccess, isError, reset: resetMutationState } = useAlertService(
    contextItemId,
    alertServiceDataSourceId,
    accommodationId,
  )

  const checkEmailValidity = (value: string) => {
    const emailRegex = /^[^\s@]+@[^\s@][^\s.@]*\.[^\s@]+$/
    return emailRegex.test(value)
  }

  const handleConfirm = () => {
    const isValid = checkEmailValidity(email)
    if (isValid) {
      resetMutationState()
      mutate(email)
    }
    else {
      setIsValidEmail(false)
    }
  }

  const handleOnBlur = () => {
    const isValid = checkEmailValidity(email)
    setIsValidEmail(isValid)
  }

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
  }

  return (
    <Dialog
      icon="Bell"
      text={intl.formatMessage({ id: 'prices_no_available_title' })}
      supportingText={intl.formatMessage({ id: 'prices_no_available_message' })}
      type="custom"
      className={cn(styles.dialogWrapper, showBorder && styles.dialogWrapperWithBorder)}
      actionsSlot={(
        <div className={styles.dialogContent}>
          {isSuccess && (
            <Banner
              color="success"
              size="M"
              hasIcon
              contentIsCentered
              text={intl.formatMessage({ id: 'price_alert_service-success-title' })}
            />
          )}
          {!isSuccess && (
            <>
              <TextField
                label={intl.formatMessage({ id: 'email_address' })}
                value={email}
                onChange={handleOnChange}
                onBlur={handleOnBlur}
                feedbackText={intl.formatMessage({ id: 'price_alert_service-error' })}
                status={!isValidEmail ? 'error' : 'default'}
                formFieldClass={styles.textFieldFullWidth}
              />
              <Button onClick={handleConfirm} disabled={isLoading} fullWidth>
                {intl.formatMessage({ id: 'prices_no_available_button' })}
              </Button>
            </>
          )}
          {isError && <AlertServiceErrorBanner className={styles.errorMessage} />}
        </div>
      )}
    />
  )
}
